import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/collect/rainv2_top_title.png'
import _imports_1 from '@/assets/collect/rainv2_close.png'
import _imports_2 from '@/assets/collect/rainv2_clock.png'


const _hoisted_1 = { class: "popupContainer" }
const _hoisted_2 = { class: "collect_Container" }
const _hoisted_3 = { class: "top_head" }
const _hoisted_4 = { class: "head_text" }
const _hoisted_5 = { class: "time_container" }
const _hoisted_6 = { class: "time_title" }
const _hoisted_7 = { class: "bottom_text" }
const _hoisted_8 = { class: "line_text" }
const _hoisted_9 = { class: "line_text" }
const _hoisted_10 = { class: "line_text" }

import StatusPopup from '@/components/common/statusPopup.vue'
import { ref, nextTick, onUnmounted, onMounted, watch, computed } from 'vue'
import RainOverlay from '@/components/common/rainOverlay.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'collectTimeDropPopup',
  setup(__props, { expose: __expose }) {

const show = ref(false)
const statusPopupRef = ref()

const timeList = ref([{ time: '05.30-06.29' }, { time: '06.30-07.29' }, { time: '07.30-08.29' }, { time: '05.30-06.29' },
{ time: '05.30-06.29' }, { time: '05.30-06.29' }, { time: '05.30-06.29' }, { time: '05.30-06.29' },
{ time: '05.30-06.29' }, { time: '05.30-06.29' }, { time: '05.30-06.29' }, { time: '05.30-06.29' },

])
const halfLength = Math.ceil(timeList.value.length / 2)

const firstHalf = computed(() => timeList.value.slice(0, halfLength))
const secondHalf = computed(() => timeList.value.slice(halfLength))
const open = () => {
    show.value = true
}
const close = () => {
    show.value = false
}
const handleClick = () => {
    statusPopupRef.value.open()
}

__expose({
    open,
    close
})


return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_popup, {
      show: show.value,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
      position: "center",
      "overlay-style": { overflow: 'hidden', zIndex: '10000' },
      style: {
        width: '100%',
        height: '100vh',
        color: '#fff',
        background: 'transparent',
        display:'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: '10001'
    }
    }, {
      default: _withCtx(() => [
        _createVNode(RainOverlay),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "",
              onClick: handleClick
            }),
            _createElementVNode("div", { class: "close_button" }, [
              _createElementVNode("img", {
                src: _imports_1,
                alt: "",
                onClick: close
              })
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, "R$ 5.000.000 " + _toDisplayString(_ctx.$t('collect.remainingMaxTIme')), 1),
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "head_text" }, [
                _createTextVNode("R$ "),
                _createElementVNode("span", null, "7.777")
              ], -1))
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, " 12X " + _toDisplayString(_ctx.$t('collect.perDay')), 1),
              _createVNode(_component_van_row, {
                gutter: "16",
                class: "sub_container"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_col, { span: "12" }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(firstHalf.value, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item.time,
                          class: "row_section"
                        }, [
                          _createVNode(_component_van_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_van_col, {
                                class: "point_star",
                                span: "4"
                              }, {
                                default: _withCtx(() => _cache[2] || (_cache[2] = [
                                  _createElementVNode("img", {
                                    src: _imports_2,
                                    alt: ""
                                  }, null, -1)
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_van_col, {
                                class: "point_text",
                                span: "20"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.time), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]))
                      }), 128))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_van_col, { span: "12" }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(secondHalf.value, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item.time,
                          class: "row_section"
                        }, [
                          _createVNode(_component_van_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_van_col, {
                                class: "point_star",
                                span: "4"
                              }, {
                                default: _withCtx(() => _cache[3] || (_cache[3] = [
                                  _createElementVNode("img", {
                                    src: _imports_2,
                                    alt: ""
                                  }, null, -1)
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_van_col, {
                                class: "point_text",
                                span: "20"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.time), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_van_row, { style: {"padding-bottom":"10px"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_col, {
                    span: "6",
                    class: ""
                  }, {
                    default: _withCtx(() => _cache[4] || (_cache[4] = [
                      _createElementVNode("div", { class: "line1" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_van_col, {
                    span: "12",
                    class: "title"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, _toDisplayString(_ctx.$t('common.activityTitle')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_van_col, {
                    span: "6",
                    class: ""
                  }, {
                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                      _createElementVNode("div", { class: "line2" }, null, -1)
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('collect.lineText1')) + " R$ 5.000.000. ", 1),
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('collect.lineText2')) + " R$ 7.777 ", 1),
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('collect.lineText3')), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(StatusPopup, {
      ref_key: "statusPopupRef",
      ref: statusPopupRef,
      content: _ctx.$t('collect.oopsText') 
    }, null, 8, ["content"])
  ], 64))
}
}

})